import { Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function Aguardando() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6 text-center">
      <div className="mx-auto h-20 w-20 rounded-full bg-primary/10 flex items-center justify-center">
        <Clock className="h-10 w-10 text-primary" />
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-bold">Tudo certo por aqui!</h1>
        <p className="text-muted-foreground">
          Recebemos seus documentos. Nosso RH vai conferir e te avisar pelos
          contatos que você informou.
        </p>
      </div>
      <Card>
        <CardContent className="p-5 text-sm text-muted-foreground space-y-2 text-left">
          <p>• Você pode fechar essa página com tranquilidade.</p>
          <p>• Se algum documento precisar ser refeito, vamos avisar.</p>
          <p>• Em caso de dúvida, fale com o RH.</p>
        </CardContent>
      </Card>
      <Button variant="outline" size="lg" className="w-full h-12" onClick={() => navigate('/candidato/documentos')}>
        Revisar meus documentos
      </Button>
    </div>
  );
}
